import React, {useState, useEffect} from 'react';
import {
  Avatar,
  Typography,
  Accordion,
  AccordionHeader,
  AccordionBody,
  IconButton,
  Drawer,
  Input,
  Switch,
  Dialog,
  Card, CardBody, DialogFooter
} from "@material-tailwind/react";
import { useParams } from 'react-router-dom';
import Select from 'react-select';
import PatientDetailTabs from '../components/PatientDetailTabs';
import axios from 'axios';
import {
  EyeIcon,
  EyeSlashIcon,
} from "@heroicons/react/24/solid";
import {ChevronUpDownIcon, MagnifyingGlassIcon} from "@heroicons/react/24/outline";
import axiosInstance from "../axios/axiosInstance";
import {useVisitId} from "../context/VisitIdContext";
import {fetchVisits} from "../services/visitService";
import CreateVisit from "../components/CreateVisit";
import {Spin, Button, Checkbox} from "antd";
import toast from "react-hot-toast";
import {PageCard, PageShell} from "../components/ui";
import { useTranslation } from 'react-i18next';

function Icon({ id, open }) {
  return (
      <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={2}
          stroke="currentColor"
          className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
      </svg>
  );
}

export default function PatientDetails() {
  const { t } = useTranslation();
  const { index } = useParams();
  const [patient, setPatient] = useState(null);
  const [open, setOpen] = useState(0);
  const [partnerName, setPartnerName] = useState(null);
  const [districtName, setDistrictName] = useState(null);
  const [provinceName, setProvinceName] = useState(null);
  const [epidemData, setEpidemData] = useState([]);
  const [visits, setVisits] = useState({});
  const [visitId, setVisitId] = useState(null);
  const [dataCache, setDataCache] = useState({});
  const [selectedEpidem, setSelectedEpidem] = useState(null);
  const [selectedEpidemIds, setSelectedEpidemIds] = useState({});

  const [mostRecentVisit, setMostRecentVisit] = useState(null);
  

  useEffect(() => {
    if (visits && Object.keys(visits).length > 0) {
      const patientVisits = visits[index];
      if (Array.isArray(patientVisits)) {
        const recentVisit = patientVisits.reduce((latest, visit) => {
          if (!visit.parent_id && ["queue", "examined", "new"].includes(visit.status)) {
            if (!latest || new Date(visit.date_at) > new Date(latest.date_at)) {
              return visit;
            }
          }
          return latest;
        }, null);
        setMostRecentVisit(recentVisit);
      }
    }
  }, [visits, index]);

  const fetchPatientVisits = async () => {
    try {
        let visitData = [];
        const fetchAllPages = async (patientId) => {
            let allData = [];
            let page = 1;
            let lastPage = 1;

            while (page <= lastPage) {
                try {
                    const response = await fetchVisits(patientId, page);
                    const pageData = response.data.data;
                    const meta = response.data.meta;

                    allData = [...allData, ...pageData];
                    lastPage = meta.last_page; // обновляем количество страниц
                    page += 1; // переходим к следующей странице
                } catch (error) {
                    console.error(`Ошибка при получении данных со страницы ${page}:`, error);
                    break;
                }
            }

            return allData;
        };
        visitData = await fetchAllPages(index);

        // Находим последний визит пациента
        const recentVisit = visitData.find(visit =>
            visit.parent_id === null &&
            (visit.bill === "payed" || visit.bill === "pending") && (visit.status === "new" || visit.status === "examined" || visit.status === "queue")
        );

        // Устанавливаем состояния
        setVisitId(recentVisit ? recentVisit.id : null);
        setVisits(prevVisits => ({
            ...prevVisits,
            [index]: visitData,
        }));
        setMostRecentVisit(recentVisit);
    } catch (error) {
        console.error('Error fetching patient visits:', error);
    }
};

  useEffect(() => {
    fetchPatientVisits();
  }, [index]);



  const handleSwitchChange = (epidemId) => {
    setEpidemData(prevState =>
        prevState.map(item =>
            item.id === epidemId ? { ...item, active: !item.active } : item
        )
    );

    setSelectedEpidemIds(prevState => ({
      ...prevState,
      [epidemId]: !prevState[epidemId]
    }));
  };

  const [isVisible, setIsVisible] = useState(true);

  const toggleVisibility = () => {
    setIsVisible(prev => !prev);
  };



  const handleOpen = (value) => setOpen(open === value ? 0 : value);

  const [openEpidem, setOpenEpidem] = React.useState(false);

  const handleOpenEpidem = () => {
    setOpenEpidem(!openEpidem);
    if (!openEpidem) {
      fetchRecords(); // Вызываем fetchRecords только при открытии раздела
    }
  };

  const token = localStorage.getItem('token');
  useEffect(() => {
    fetchRecords();
    fetchPatient();
  }, [index]);

  const fetchRecords = async () => {
    try {
      const response = await axiosInstance.get("/epidemiological");
      const epidemData = response.data.data;
      setEpidemData(epidemData);
      if (patient) {
        const initialSelectedEpidemIds = patient.epidem.map(item => item.id);
        const updatedEpidemData = epidemData.map(item => ({
          ...item,
          active: initialSelectedEpidemIds.includes(item.id)
        }));
        setEpidemData(updatedEpidemData);
      }
    } catch (error) {
      console.error("Ошибка при получении списка эпидемии:", error);
    }
  };
  const fetchPatient = async () => {
    try {
      const response = await axiosInstance.get(`/patients/${index}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });
      setPatient(response.data.data);
      const initialSelectedEpidemIds = response.data.data.epidem.map(item => item.id);
      setSelectedEpidemIds(initialSelectedEpidemIds);

      // Отфильтровать выбранные эпидемии и поместить их в начало массива
      const selectedEpidemData = response.data.data.epidem.filter(item => initialSelectedEpidemIds.includes(item.id));
      const unselectedEpidemData = response.data.data.epidem.filter(item => !initialSelectedEpidemIds.includes(item.id));
      const sortedEpidemData = [...selectedEpidemData, ...unselectedEpidemData];
      setEpidemData(sortedEpidemData);
      if (response.data.data.partner_id) {
        const partnerResponse = await axiosInstance.get(`/partners/${response.data.data.partner_id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          }
        });
        setPartnerName(partnerResponse.data.data.name);
      }
      if (response.data.data.district_id) {
        const districtResponse = await axiosInstance.get(`/global/district/${response.data.data.district_id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          }
        });
        setProvinceName(districtResponse.data.data.province.name);
        setDistrictName(districtResponse.data.data.name);
      }
    } catch (error) {
      console.error("Ошибка при получении информации о пациенте:", error);
    }
  };

  const sendEpidemData = async () => {
    const activeEpidems = epidemData.filter(item => item.active).map(item => item.id);
    const data = { epidem: activeEpidems };


    try {
      const response = await axiosInstance.post(data);
      console.log("Epidem data sent successfully:", response.data);
      fetchPatient();
      toast.success(t('patientCard.epidemAdded'));
      setOpenEpidem(false);
    } catch (error) {
      console.error("Error sending epidem data:", error);
    }
  };






  const CUSTOM_ANIMATION = {
    mount: { scale: 1 },
    unmount: { scale: 0.9 },
  };

  if (!patient) {
    return <Spin colorPrimary="#000" tip={t('common.loading')} ></Spin>;
  }



  return (
      <PageShell>
        <div className="flex items-center text-sm text-slate-600">
            <Switch  label={isVisible ? <div className="flex gap-x-1 items-center text-sm">
                <EyeSlashIcon className="w-4 h-4"/> {t('patientCard.hideProfile')}
              </div> :
              <div className="flex gap-x-1 items-center text-sm">
                <EyeIcon className="w-4 h-4"/> {t('patientCard.showProfile')}
              </div>
          }
                   checked={isVisible}
                   onChange={toggleVisibility}
          />

        </div>

        <div className={`grid gap-2.5 md:gap-4 patient-card-page ${isVisible ? 'grid-cols-1 xl:grid-cols-[minmax(0,380px)_minmax(0,1fr)]' : 'grid-cols-1'}`}>
          {isVisible && (
              <PageCard className="p-3 sm:p-4">
                <div>
                  <h3 className="text-base sm:text-lg font-semibold leading-7 text-slate-900 m-0">{t('patientCard.title')}</h3>
                </div>
                <div className="mt-3 border-t border-gray-100">
                  <dl className="divide-y divide-gray-100">
                    <div className="py-3 grid grid-cols-1 gap-2">
                      <div className="flex items-center gap-4">
                        <Avatar loading="lazy" src={`${patient.avatar}`} size="lg" alt="avatar" variant="rounded"/>
                        <div>
                          <h3 className="text-base font-semibold leading-7 text-gray-900">{patient.name}</h3>
                          <p className="mt-0 max-w-2xl text-sm leading-6 text-gray-500">{t('common.code')}: {patient.code}</p>
                        </div>
                      </div>
                      <CreateVisit mostRecentVisit={mostRecentVisit} onUpdateVisits={fetchPatient} visit={visitId} patientId={index}/>
                    </div>
                    <div className="py-2.5 grid grid-cols-1 sm:grid-cols-3 gap-0.5 sm:gap-4">
                      <dt className="text-sm font-medium leading-6 text-gray-900">{t('patientCard.workAddress')}:</dt>
                      <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{patient.work_address}</dd>
                    </div>
                    <div className="py-2.5 grid grid-cols-1 sm:grid-cols-3 gap-0.5 sm:gap-4">
                      <dt className="text-sm font-medium leading-6 text-gray-900">{t('patientCard.birthDate')}:</dt>
                      <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">1988-04-13</dd>
                    </div>
                    <div className="py-2.5 grid grid-cols-1 sm:grid-cols-3 gap-0.5 sm:gap-4">
                      <dt className="text-sm font-medium leading-6 text-gray-900">{t('patientCard.address')}:</dt>
                      <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">{patient.home_address}</dd>
                    </div>
                    <div className="py-2.5 grid grid-cols-1 sm:grid-cols-3 gap-0.5 sm:gap-4">
                      <dt className="text-sm font-medium leading-6 text-gray-900">{t('patientCard.phone')}:</dt>
                      <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                        {patient.phone}
                      </dd>
                    </div>
                    <div className="py-2.5 grid grid-cols-1 sm:grid-cols-3 gap-0.5 sm:gap-4">
                      <dt className="text-sm font-medium leading-6 text-gray-900">{t('patientCard.province')}:</dt>
                      <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                        {provinceName ? provinceName : t('patientCard.noDistrict')}
                      </dd>
                    </div>
                    <div className="py-2.5 grid grid-cols-1 sm:grid-cols-3 gap-0.5 sm:gap-4">
                      <dt className="text-sm font-medium leading-6 text-gray-900">{t('patientCard.cityDistrict')}:</dt>
                      <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                        {districtName ? districtName : t('patientCard.noDistrict')}
                      </dd>
                    </div>
                    <div className="py-2.5 grid grid-cols-1 sm:grid-cols-3 gap-0.5 sm:gap-4">
                      <dt className="text-sm font-medium leading-6 text-gray-900">{t('patientCard.profession')}:</dt>
                      <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                        {patient.profession}
                      </dd>
                    </div>
                    <div className="py-2.5 grid grid-cols-1 sm:grid-cols-3 gap-0.5 sm:gap-4">
                      <dt className="text-sm font-medium leading-6 text-gray-900">{t('patientCard.sentBy')}:</dt>
                      <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                        {partnerName ? partnerName : t('patientCard.noPartner')}
                      </dd>
                    </div>
                    <div className="py-2.5 grid grid-cols-1 sm:grid-cols-3 gap-0.5 sm:gap-4">
                      <dt className="text-sm font-medium leading-6 text-gray-900">{t('common.remark')}:</dt>
                      <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                        {patient.remark}
                      </dd>
                    </div>
                    <div className="py-1">
                      <Accordion animate={CUSTOM_ANIMATION} open={open === 1} icon={<Icon id={1} open={open}/>}>
                        <AccordionHeader className='text-sm'
                                         onClick={() => handleOpen(1)}>{t('epidem.title')}</AccordionHeader>
                        <AccordionBody>
                          <div className='flex gap-4'>
                            {/*<Select*/}
                            {/*    options={epidemData.map(item => ({value: item.id, label: item.name}))}*/}
                            {/*    value={selectedEpidem}*/}
                            {/*    onChange={(selectedOption) => setSelectedEpidem(selectedOption)}*/}
                            {/*    placeholder="Выберите эпидемиологическую запись..."*/}
                            {/*/>*/}
                            <label
                                className="relative w-full bg-white min-w-sm flex flex-col md:flex-row items-center justify-center border py-2 px-2 rounded-md gap-2  focus-within:border-gray-300"
                                htmlFor="search-bar"
                            >

                              <input
                                  id="search-bar"
                                  placeholder={t('common.search')}
                                  className="px-8 py-1 w-full rounded-md flex-1 outline-none bg-white"

                              />


                              <Button  size="md"><MagnifyingGlassIcon
                                  className="h-5 w-5"/></Button>
                              <Button onClick={handleOpenEpidem}>{t('common.add')}</Button>


                            </label>

                          </div>
                          <div className="py-3 overflow-x-auto">
                            <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                              <table className="min-w-full divide-y divide-gray-200">
                                <thead className="bg-gray-50">
                                <tr>
                                  <th scope="col"
                                      className="px-3 py-2.5 text-left text-xs font-semibold text-slate-500">
                                    {t('patientCard.colTitle')}
                                  </th>
                                  <th scope="col"
                                      className="px-3 py-2.5 text-left text-xs font-semibold text-slate-500">
                                    {t('common.actions')}
                                  </th>
                                </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200">


                                {patient.epidem.map(epidem => (
                                    <tr key={epidem.id}>
                                      <td className="px-3 py-2.5 text-sm text-slate-700">{epidem.name}</td>
                                      <td className="px-3 py-2.5 text-sm text-slate-700">
                                        {epidem.description ? epidem.description : t('patientCard.notAvailable')}
                                      </td>
                                    </tr>
                                ))}
                                </tbody>
                              </table>
                            </dd>
                          </div>

                        </AccordionBody>
                      </Accordion>
                    </div>
                  </dl>
                </div>
              </PageCard>
          )}
          <PageCard className="min-w-0 tabs-part p-2 sm:p-3 xl:h-[85vh] xl:overflow-y-auto">
            <PatientDetailTabs onUpdateVisits={fetchPatientVisits} mostRecentVisit={mostRecentVisit} setMostRecentVisit={setMostRecentVisit} visits={visits} visitId={visitId} patientName={patient.name} mkb10={patient.mkb10}  remark={patient.remark} patientId={index}/>
          </PageCard>
        </div>

        <Dialog size="lg" className="bg-transparent shadow-none" open={openEpidem} handler={handleOpenEpidem}>
          <Card className="mx-auto w-full ">
            <CardBody className="flex flex-col gap-4 max-h-[70vh] overflow-auto">
              <table className="mt-4 w-full table-auto text-left">
                <thead>
                <tr>
                  <th className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-4 transition-colors hover:bg-blue-gray-50">
                    <Typography variant="small" color="blue-gray"
                                className="flex items-center justify-between gap-2 font-normal leading-none opacity-70">
                      ID{" "}
                    </Typography>
                  </th>
                  <th className="cursor-pointer border-y border-blue-gray-100 bg-blue-gray-50/50 p-4 transition-colors hover:bg-blue-gray-50">
                    <Typography variant="small" color="blue-gray"
                                className="flex items-center justify-between gap-2 font-normal leading-none opacity-70">
                      {t('patientCard.patientFio')}{" "}
                      <ChevronUpDownIcon strokeWidth={2} className="h-4 w-4"/>
                    </Typography>
                  </th>
                </tr>
                </thead>
                <tbody>
                {epidemData.map((item) => (
                    <tr key={item.id}>
                      <td className="px-3 py-2.5 text-sm text-slate-700">{item.name}</td>
                      <td className="px-3 py-2.5 text-sm text-slate-700">
                        <Checkbox
                            checked={item.active}
                            onChange={() => handleSwitchChange(item.id)}
                        >
                           {item.active ? t('common.add') : t('patientCard.added')}
                        </Checkbox>
                      </td>
                    </tr>
                ))}
                </tbody>
              </table>
            </CardBody>

            <DialogFooter>
              <Button className="w-full" onClick={sendEpidemData}>{t('common.save')}</Button>
            </DialogFooter>

          </Card>
        </Dialog>
      </PageShell>
  );
}
